import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import './HomePage.css';


import {
  Link
} from "react-router-dom";


function HomePage() {
    return (
      <div className="container py-4" style={ {
        maxWidth : "1102px"
      }}>
        <br></br>
        <div
      className="hero text-center text-white d-flex flex-column justify-content-center align-items-center"
      style={{
      backgroundImage: "url('/2.webp')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      
      
    
      padding: "2rem",
      width : "1102px", 
      height : "514px" ,
      borderRadius : "20px",
      alignItems : "center"
      }}
  >
    <h className="display-5 fw-bold" style={{
      fontWeight : "700", fontSize : "50px" , lineHeight : "60px" , letterSpacing : "-2px"
    }}>Ignite Your Digital Future. Transform Your Business.</h>
    <p className="mt-3 col-md-8" style= {{
      fontSize : "16px",
      fontWeight : "400", 
      lineHeight : "24px", 
      letterSpacing :"0px", 
    
    }}>
      Briospark delivers innovative digital transformation solutions, empowering telecommunications and banking leaders to thrive in the evolving digital landscape.
    </p>
  </div>
  
  
        <div className="section" style={ { textAlign : "center"}}>
          <p2 className="lead" style = {{
            fontSize : "24px", fontWeight : "400", lineHeight : "140%", letterSpacing : "0px"
          }}>
            We specialize in crafting cutting-edge software solutions that streamline operations, enhance customer experiences, and unlock new revenue streams. Our deep expertise in OSS and banking allows us to provide tailored solutions for your most critical challenges.
          </p2>
        </div>
        <hr className="section-divider" />
  
        <section className="section">
    <div className="row align-items-center">
      <div className="driving-trans col-md-6">
        <h3  style={{fontWeight : "700", fontSize : "22px", lineHeight : "28px", letterSpacing : "0px"}}>Driving Transformation, Building Trust.</h3>
        <p style = {{fontSize : "16px", fontWeight : "400", lineHeight : "24px", letterSpacing : "0px"}}>
          At Briospark, we believe in the power of technology to elevate and redefine the financial services and telecommunication landscapes.
          Our mission is to empower our clients through innovative digital solutions that not only meet current needs but anticipate future challenges.
          With every client interaction and innovation, driving progress, transparency, and impact is at every interaction.
        </p>
        <br></br>
        <Link to="/solutions" className=" text-primary" onClick={() => window.scrollTo(0, 0)} style={ {fontSize : "16px", fontWeight : "300", lineHeight : "24px", letterSpacing : "0px"}}>Learn More</Link>
      </div>
      <div className="col-md-6">
        <div className="img-container" style={{
          width : "515px",
          height : "254px",
          borderRadius : "12px"
        }}>
          <img
            src="/6.webp"
            alt="Colorful data visualization"
            className="img-fluid rounded shadow"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
  
        <section className="section row">
    {[
      {
        title: "Digital Transformation",
        text: "Empowering organizations to optimize operations with innovative digital solutions, elevate customer experiences, and achieve sustainable growth in today's evolving business landscape.",
        icon: <img src="1.webp" alt="icon" className="card-icon1" loading="lazy" />,
        background: `radial-gradient(circle at top left, #EA4436, transparent 45%),#1C2126`
      },
      {
        title: "Telecommunication",
        text: "Delivering specialized OSS solutions to streamline network operations, enhance efficient service delivery, and ensure robust infrastructure for telecom providers in demanding network environments.",
        icon: <img src="3.webp" alt="icon" className="card-icon1" loading="lazy" />,
  
        background: `radial-gradient(circle at top center, #C43B8D, transparent 60%),#1C2126`
      },
      {
        title: "Financial Services & Banking Solutions",
        text: "Our cutting-edge Banking Solutions empower financial institutions to modernize technology, enhance digital customer experiences, and thrive in the rapidly evolving digital finance landscape, gaining a competitive edge.",
        icon: <img src="7.webp" alt="icon" className="card-icon1" loading="lazy"/>,
  
        background: `radial-gradient(circle at top right, #07A5DF, transparent 45%),#1C2126`
      }
    ].map((item, i) => (
      <div className="col-md-4 mb-4" key={i}>
        <div
          className="p-4 h-100 text-white shadow-lg true-style-card position-relative"
          style={{
            background: item.background,
            borderRadius: "10px",
            border : "1px solid #3D4754"
          }}
        >
          <div className="ikonlarr icon-visible mb-3">
            {item.icon}
          </div>
          <div className="kartlar-title">
          <p  style={{fontSize : "16px",
      fontWeight: "bold",
      marginBottom: "0.5rem"}}>{item.title}</p>
      </div>
          <br></br>
          
          <p style={{fontSize: "14px",
      color: "#ccc"}}>{item.text}</p>
        </div>
      </div>
    ))}
  </section>
  
  <style>{`

    .card-icon1 {
      width: 24px;
      height: 24px;
    }
  `}</style>
  <hr
    style={{
      border: "none",
      borderTop: "1px solid #fff",
      marginTop: "40px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }}
  />
  
  <section className="section">
  <div className="our-products1" >
    <h className="mb-3" style={{ fontSize: "36px", color: "#fff", fontWeight : "700" }}>Our Products</h>
       <p className="mb-4" style={{ fontSize: "16px", color: "#fff", fontWeight : "400" }}>
      We provide tailor-made digital solutions across key areas to help telecom and banking institutions
      achieve their strategic goals.
    </p></div>
   
  
    <div className="d-flex flex-wrap gap-4 justify-content-center">
      {/* Taksit-le */}
      <Link to="/bnpl" className="nav-link-custom" onClick={() => window.scrollTo(0, 0)}>
      <div
        className="card p-3 border-0 shadow-sm"
        style={{
          backgroundColor: "#121417",
          borderRadius: "12px",
          width: "515px",
          height: "413px"
        }}
      >
        <img src="/taksitle.webp" alt="Taksit-le" className="img-fluid rounded mb-3" loading="lazy"/>
        <h className="taksit-le mb-2" style={{ fontSize: "16px", color: "#ffffff" , fontWeight : "500"}}>
          Taksit-le: Streamlined Payment Solutions
        </h>
        <p style={{ fontSize: "14px", color: "#9EABB8", fontWeight : "400" }}>
          Taksit-le is a powerful, flexible installment payment platform that empowers your customers to
          purchase goods and services with ease. Seamlessly integrated into your existing e-commerce
          and point-of-sale systems, Taksit-le offers a streamlined, user-friendly experience that boosts
          conversion rates and increases average order value.
        </p>
      </div>
      </Link>
  
      {/* Changer */}
      <Link to="/changer" className="nav-link-custom" onClick={() => window.scrollTo(0, 0)}>
      <div
        className="card p-3 border-0 shadow-sm"
        style={{
          backgroundColor: "#121417",
          borderRadius: "12px",
          width: "515px",
          height: "413px"
        }}
      >
        <img src="/changer.webp" alt="Changer" className="img-fluid rounded mb-3" loading="lazy" />
        <h className="changer mb-2" style={{ fontSize: "16px", color: "#ffffff" , fontWeight : "500"}}>
          Changer: Change Your Points into Real Money!
        </h>
        <p style={{ fontSize: "14px", color: "#9EABB8" }}>
          Instantly convert bank, wallet, and brand loyalty points into real money with seamless Masterpass integration.
          Changer automatically collects your loyalty points, transforms them into cash value, and lets you spend freely
          wherever Masterpass is accepted. Say goodbye to wasted points and hello to instant savings with Changer!
        </p>
      </div>
      </Link>
    </div>
  </section>
  
  <hr
    style={{
      border: "none",
      borderTop: "1px solid #fff",
      marginTop: "40px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }}
  />
  
        <section className="section text-center">
    <div
      className="text-white d-flex justify-content-center align-items-center"
      style={{
        background: "url('/12.webp') center/cover no-repeat",
        padding: "5rem 2rem",
        minHeight: "60vh",
        position: "relative",
        width : "1070px",
        height : "480px",
        borderRadius : "20px"
      }}
    >
      {/* Sadece yazının arkasına hafif blur */}
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.001)",
          backdropFilter: "blur(2px)",
          WebkitBackdropFilter: "blur(2px)",
          borderRadius: "1rem",
          padding: "2rem",
          maxWidth: "800px",
          zIndex: 2
        }}
      >
        <h2 className="fw-bold display-4 mb-3" style={ {
          fontWeight : "700",
          fontSize : "50px"
        }}>Navigate the Future of Telecom & Banking</h2>
        <p className="lead mb-4"  style={{
          color : "#fff",
          fontWeight : "400", 
          fontSize : "16px"
        }} >
          Briospark empowers telecom and banking institutions with cutting-edge digital solutions.
          Drive growth, enhance customer experiences, and gain a competitive edge in today's evolving market.
        </p>
        <Link
    to="/solutions"
    className="btn btn-primary custom-contact-btn" onClick={() => window.scrollTo(0, 0)} 
  >
    Explore Solutions
  </Link>
      </div>
    </div>
  </section>
  
  
  
  
      </div>
    );
  }
  export default HomePage;